import { defaultTheme as theme } from '@geberit/gdds';

export const textStyle = {
  paragraph: {
    xsmall: theme.fontTokens.font11,
    medium: theme.fontTokens.font11,
    large: theme.fontTokens.font11,
    xlarge: theme.fontTokens.font11,
  },
  caption: {
    xsmall: theme.fontTokens.font13,
    medium: theme.fontTokens.font13,
    large: theme.fontTokens.font13,
    xlarge: theme.fontTokens.font13,
  },
};

export const leftRightSizes = {
  GDDS: {
    left: 'oneHalf',
    right: 'oneHalf',
    left_big: 'twoThird',
    right_big: 'twoThird',
  },
  XY: { left: 'oneHalfNord', right: 'oneHalfNord' },
  NORD: { left: 'oneHalfNord', right: 'oneHalfNord' },
  KOLO: { left: 'oneHalfNord', right: 'oneHalfNord' },
  TWYFORD: { left: 'oneHalfNord', right: 'oneHalfNord' },
};

export const leftRightColumns = {
  oneHalf: {
    text: [4, 8, 6],
    image: [4, 8, 6],
  },
  oneHalfNord: {
    text: [4, 4, 5],
    image: [4, 4, 7],
  },
  twoThird: {
    text: [4, 8, 4],
    image: [4, 8, 8],
  },
};

export const leftRightDefaultColumns = leftRightColumns.oneHalf;
